export const landingRoutes = [
  // 랜딩 페이지
  {
    path: '/',
    name: 'landing',
    component: () => import('../../views/LandingView.vue'),
    meta: { isFullScreen: true }
  },
  {
    path: '/landing',
    redirect: '/'
  },
  
  // 정적 페이지들
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../../views/TermsView.vue'),
    meta: { isFullScreen: true }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../../views/ServiceView.vue'),
    meta: { isFullScreen: true }
  },
  {
    path: '/license',
    name: 'license',
    component: () => import('../../views/LicenseView.vue'),
    meta: { isFullScreen: true }
  },

  // SEO 가이드 (유입용 콘텐츠)
  {
    path: '/guide',
    name: 'guides',
    component: () => import('../../views/GuideIndexView.vue'),
    meta: { isFullScreen: true }
  },
  {
    path: '/guide/:slug',
    name: 'guide',
    component: () => import('../../views/GuideView.vue'),
    meta: { isFullScreen: true }
  }
]

